import React from 'react';
import {
    TextField,
    Datagrid,
    Show,
    ArrayField,
    SimpleShowLayout,
    DateField,
    ReferenceField,
    Button,
    useRedirect,
    useRecordContext,
    useGetList,
    Loading,
} from 'react-admin';
import { useClosedStatusId } from '../../lib/useClosedStatusId';

const dateFormat = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric',
};

const moduleVersionRowClick = (_id, _basePath, record) =>
    '/ThisSpecificModuleVersion/' + record.id;

const ModuleVersionEditButton = ({ label, closedStatusId }) => {
    const record = useRecordContext();
    const redirect = useRedirect();

    const isEditable = record?.statusId !== closedStatusId;
    if (!isEditable) {
        return <></>;
    }

    const onClick = (e) => {
        e.stopPropagation();
        redirect('edit', 'ThisSpecificModuleVersion', record.id);
    };

    return <Button onClick={onClick}>{label}</Button>;
};

export const ModuleVersionsShow = (props) => {
    const closedStatusId = useClosedStatusId();

    return (
        <Show {...props}>
            <SimpleShowLayout>
                <TextField source="id" />
                <ArrayField source="versions">
                    <Datagrid
                        rowClick={moduleVersionRowClick}
                        bulkActionButtons={false}
                    >
                        <TextField source="version" />
                        <TextField source="shortTitle" />
                        <ReferenceField reference="Status" source="statusId">
                            <TextField source="Title" />
                        </ReferenceField>{' '}
                        <DateField
                            source="validationFrom"
                            options={dateFormat}
                        />
                        <DateField source="validationTo" options={dateFormat} />
                        <ModuleVersionEditButton
                            label="Edit"
                            closedStatusId={closedStatusId}
                        />
                    </Datagrid>
                </ArrayField>
            </SimpleShowLayout>
        </Show>
    );
};
